import { apiFetch } from '@/shared/api/client'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'

export type SimulateStoreReceiveResponse = {
  delivery_id: string
  received_at: string
}

/**
 * Meniru aplikasi toko yang men-scan QR handover lalu menerima seluruh barang.
 * Token handover dikonsumsi di backend dan delivery ditandai diterima penuh.
 */
export async function simulateStoreReceive(
  token: string,
): Promise<SimulateStoreReceiveResponse> {
  if (shouldUseDelmanMock()) {
    await new Promise((r) => setTimeout(r, 300))
    return { delivery_id: '', received_at: new Date().toISOString() }
  }

  return apiFetch<SimulateStoreReceiveResponse>('/handover/receive', {
    method: 'POST',
    body: JSON.stringify({ token }),
  })
}
